// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2bde6","title":"ClientInsurance_title__2gbe9","itemText":"ClientInsurance_itemText__JKGv3"};